
import { computed, defineComponent, reactive } from 'vue';
import { IOption } from '@/core/models/AntDesign/IOption';
import { useTelaBase } from '@/core/composables/TelaBase';
import ServicoBalancoEstoque from '@/servicos/Estoques/ServicoBalancoEstoque';

export default defineComponent({
  name: 'SelecionarStatusBalancoEstoque',
  props: {
    varios: {
      type: Boolean,
      default: false,
    },
    codigoSelecionado: {
      type: Number || undefined,
    },
    codigosSelecionados: {
      type: Array as () => number[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Selecione',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:codigoSelecionado', 'update:codigosSelecionados', 'change'],
  setup(props, { emit }) {
    const { montaOpcoesComListaItemGenerico } = useTelaBase();

    const state = reactive({
      listaStatusBalancoEstoque: [] as IOption[],
    });

    (async () => {
      const listaStatusBalancoEstoque = await new ServicoBalancoEstoque().obterListaStatus();
      state.listaStatusBalancoEstoque = montaOpcoesComListaItemGenerico(listaStatusBalancoEstoque);
    })();

    function obterStatusBalancoEstoque():any {
      return props.codigoSelecionado;
    }

    const computedCodigoSelecionado = computed({
      get: () => obterStatusBalancoEstoque(),
      set: (val: number) => {
        emit('update:codigoSelecionado', val);
      },
    });

    const computedCodigosSelecionados = computed({
      get: () => props.codigosSelecionados,
      set: (val: number[]) => {
        emit('update:codigosSelecionados', val);
      },
    });

    function change() {
      emit('change', props.varios ? props.codigosSelecionados : props.codigoSelecionado);
    }

    return {
      props,
      state,
      computedCodigoSelecionado,
      computedCodigosSelecionados,
      change,
    };
  },
});
